export default "__VITE_ASSET__DEEijhgy__"